import coordinatesPropTypes from 'config/coordinatesPropTypes';
import PropTypes from 'prop-types';
import { keys, values } from 'lodash';
import headerBackgroundImageSize from 'config/sectionHeader/headerBackgroundImageSize';
import headerContentAlignment from 'config/sectionHeader/headerContentAlignment';
import * as headerLogoImageSizePresets from '../../components/headerCustomizer/constants/headerLogoImageSizePresets';

export const headerBackgroundImageSizePropType = PropTypes.oneOf(
  keys(headerBackgroundImageSize),
);

export const headerContentAlignmentPropTypes = PropTypes.oneOf(
  keys(headerContentAlignment),
);

export const headerLogoSizePresetPropTypes = PropTypes.oneOf(
  values(headerLogoImageSizePresets),
);

export const sizePropTypes = PropTypes.shape({
  width: PropTypes.number,
  height: PropTypes.number,
});

export const logoContentPropTypes = {
  logoImageUrl: PropTypes.string,
  logoImageAlign: headerContentAlignmentPropTypes,
  containerSize: sizePropTypes,
  logoImageLinkUrl: PropTypes.string,
  logoImageSizePreset: headerLogoSizePresetPropTypes,
  logoImageSize: sizePropTypes,
  logoWithTextAlign: headerContentAlignmentPropTypes,
};

export const textContentPropTypes = {
  clientUuid: PropTypes.string,
  textContent: PropTypes.object,
};

export const sectionHeaderPropTypes = {
  backgroundImageUrl: PropTypes.string,
  backgroundImageSize: headerBackgroundImageSizePropType,
  containerClassName: PropTypes.string,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  isPlaceholder: PropTypes.bool,
  backgroundCoords: coordinatesPropTypes,
  imageMoveDirection: PropTypes.string,
  imgSize: sizePropTypes,
  isContentEnabled: PropTypes.bool,
  layout: PropTypes.string.isRequired,
  ...logoContentPropTypes,
  ...textContentPropTypes,
};
